import { CrudStoreItemPartner360 } from 'legacy/lut/classes/models/partner360/CrudStoreItemPartner360'
import { IELTContact } from 'legacy/lut/classes/models/partner360/ELT/IELTContact'
import { IELTData } from 'legacy/lut/classes/models/partner360/ELT/IELTData'
import { IELTFinancialData } from 'legacy/lut/classes/models/partner360/ELT/IELTFinancialData'
import { IELTHPContact } from 'legacy/lut/classes/models/partner360/ELT/IELTHPContact'
import { IELTSearch } from 'legacy/lut/classes/models/partner360/ELT/IELTSearch'
import { IELTVersionsCount } from 'legacy/lut/classes/models/partner360/ELT/IELTVersionsCount'
import { IForm3rdPartySolutions } from 'legacy/lut/classes/models/partner360/IForm3rdPartySolutions'
import { IFormTopPartnersDetails } from 'legacy/lut/classes/models/partner360/IFormAccessJBP'
import { IFormActionCapabilities } from 'legacy/lut/classes/models/partner360/IFormActionCapabilities'
import { IFormActionsPlan } from 'legacy/lut/classes/models/partner360/IFormActionsPlan'
import {
  IFormActionsPlanMDF,
  IFormActionsPlanMDFFYears,
} from 'legacy/lut/classes/models/partner360/IFormActionsPlanMDF'
import { IFormBPExportFiles } from 'legacy/lut/classes/models/partner360/IFormBPExportFiles'
import { IFormCommitment } from 'legacy/lut/classes/models/partner360/IFormCommitment'
import { IFormCommitmentHistory } from 'legacy/lut/classes/models/partner360/IFormCommitmentHistory'
import { IFormCompensation } from 'legacy/lut/classes/models/partner360/IFormCompensation'
import { IFormCompleteness } from 'legacy/lut/classes/models/partner360/IFormCompleteness'
import { IFormCountryManagerSummary } from 'legacy/lut/classes/models/partner360/IFormCountryManagerSummary'
import {
  IFormDaaSPlanActuals,
  PSEndCustomer,
} from 'legacy/lut/classes/models/partner360/IFormDaaSPlanActuals'
import { IFormDistributorScope } from 'legacy/lut/classes/models/partner360/IFormDistributorScope'
import { IFormDistributorScopeData } from 'legacy/lut/classes/models/partner360/IFormDistributorScopeData'
import { IFormExceptionalPartnerSpecialization } from 'legacy/lut/classes/models/partner360/IFormExceptionalPartnerSpecialization'
import { IFormExecutiveReport } from 'legacy/lut/classes/models/partner360/IFormExecutiveReport'
import { IFormExtendedPartnerTCAcceptanceReport } from 'legacy/lut/classes/models/partner360/IFormExtendedPartnerTCAcceptanceReport'
import { IFormGeneralPlanning } from 'legacy/lut/classes/models/partner360/IFormGeneralPlanning'
import {
  IFormActualsAndPlans,
  IFormHistoricalResults,
} from 'legacy/lut/classes/models/partner360/IFormHistoricalResults'
import {
  IFormHPContacts,
  IFormJBPHPContactChangeRequest,
  IFormJBPHPContactRoles,
  IFormJBPSalesTeam,
  IHpContactManagement,
} from 'legacy/lut/classes/models/partner360/IFormHPContacts'
import { IFormLookupTool } from 'legacy/lut/classes/models/partner360/IFormLookupTool'
import { IFormMarketShare } from 'legacy/lut/classes/models/partner360/IFormMarketShare'
import { IFormMasterDealerBlockedPartners } from 'legacy/lut/classes/models/partner360/IFormMasterDealerBlockedPartners'
import { IFormMIFCompensation } from 'legacy/lut/classes/models/partner360/IFormMIFCompensation'
import { IFormMIFReport } from 'legacy/lut/classes/models/partner360/IFormMIFReport'
import { IFormMPSDetails } from 'legacy/lut/classes/models/partner360/IFormMPSSummary'
import { IFormOfferingList } from 'legacy/lut/classes/models/partner360/IFormOfferingList'
import { IFormOptionsJBP } from 'legacy/lut/classes/models/partner360/IFormOptionsJBP'
import { IFormPartnerBasicInfo } from 'legacy/lut/classes/models/partner360/IFormPartnerBasicInfo'
import { IFormPartnerContacts } from 'legacy/lut/classes/models/partner360/IFormPartnerContacts'
import { IFormPartnerDaasSummary } from 'legacy/lut/classes/models/partner360/IFormPartnerDaasSummary'
import { IFormPartnerDevicesInfo } from 'legacy/lut/classes/models/partner360/IFormPartnerDevicesInfo'
import { IFormPartnerMarketInfo } from 'legacy/lut/classes/models/partner360/IFormPartnerMarketInfo'
import { IFormPartnerMarketLeasing } from 'legacy/lut/classes/models/partner360/IFormPartnerMarketLeasing'
import { IFormPartnerMasterDealer } from 'legacy/lut/classes/models/partner360/IFormPartnerMasterDealer'
import { IFormPartnerMasterDealerReport } from 'legacy/lut/classes/models/partner360/IFormPartnerMasterDealerReport'
import { IFormPartnerSales } from 'legacy/lut/classes/models/partner360/IFormPartnerSales'
import { IFormPartnerSalesScheme } from 'legacy/lut/classes/models/partner360/IFormPartnerSalesScheme'
import {
  IFormPartnerShareOfBusiness,
  IFormSOBResults,
} from 'legacy/lut/classes/models/partner360/IFormPartnerShareOfBusiness'
import { IFormPartnerTargets } from 'legacy/lut/classes/models/partner360/IFormPartnerTargets'
import { IFormPBMList } from 'legacy/lut/classes/models/partner360/IFormPBMList'
import { IFormProgramsManagementAdmin } from 'legacy/lut/classes/models/partner360/IFormProgramsManagementAdmin'
import { IFormProgramsManagementPartner } from 'legacy/lut/classes/models/partner360/IFormProgramsManagementPartner'
import { IFormSalesTeamBusinessUnits } from 'legacy/lut/classes/models/partner360/IFormSalesTeamBusinessUnits'
import { IFormSalesTeamRequest } from 'legacy/lut/classes/models/partner360/IFormSalesTeamRequest'
import { IFormSalesTeamRoles } from 'legacy/lut/classes/models/partner360/IFormSalesTeamRoles'
import { IFormSummaryAchievements } from 'legacy/lut/classes/models/partner360/IFormSummaryAchievements'
import { IFormTargetsByOfferingV2 } from 'legacy/lut/classes/models/partner360/IFormTargetsByOfferingV2'
import { IFormThingsToImprove } from 'legacy/lut/classes/models/partner360/IFormThingsToImprove'
import { IFormTopTargetAccounts } from 'legacy/lut/classes/models/partner360/IFormTopTargetAccounts'
import { IHistoricalResultsChartOptions } from 'legacy/lut/classes/models/partner360/IHistoricalResultsChartOptions'
import { IJBPDataInsight } from 'legacy/lut/classes/models/partner360/IJBPDataInsight'
import {
  IJBPCountMembersInGroup,
  IJBPGroupMembersString,
  IJBPPartnerGroupsExtData,
  IPartnerGlobalGroup,
  IPartnerGroupFromT1187,
  IPartnerGroupInfo,
  ITopPartnerFromT1263,
} from 'legacy/lut/classes/models/partner360/IPartnerGroup'
import { IPartnerScopeEntity } from 'legacy/lut/classes/models/partner360/IPartnerScopeEntity'
import { ITranslationFactors } from 'legacy/lut/classes/models/partner360/ITranslationFactors'
import { IWWPartners } from 'legacy/lut/classes/models/partner360/IWWPartners'
import { MPSSummaryApi } from 'legacy/lut/classes/services/api/partner360/MPSSummaryApi'
import { PartnerDetailsApi } from 'legacy/lut/classes/services/api/partner360/PartnerDetailsApi'
import { partnerManagementApi } from 'legacy/lut/classes/services/api/partner360/PartnerManagementApi'
import {
  fetchGPKeyInitiativesRollup,
  fetchKeyInitiatives,
} from 'legacy/lut/components/widgets/public/partner360/actionsPlan/keyInitiatives'
import {
  fetchReportData,
  IComposedReport,
  IComposedReportFilters,
} from 'legacy/lut/components/widgets/public/partner360/composedReport'
import { fetchPartnersByPartnerIds } from 'legacy/lut/components/widgets/public/partner360/composedReport/api/fetchPartnersByPartnerIds'
import { IManagerMiltuselect } from 'legacy/lut/components/widgets/public/partner360/composedReport/components/filterArea/filterFields/managerMultiselect/models'
import {
  IFormTopPartners,
  IFormTopPartnersToAdd,
} from 'legacy/lut/components/widgets/public/partner360/topPartnersWidget/models'
import { ICachedProgramType } from 'legacy/lut/services/partner360/configuration/models'

import { IForm } from 'core-components/classes/models/IForm'
import { IDataProviderFilter, IFilter, Operator, Static } from 'core-components/types'
import { Logic } from 'core-components/types/ICrudHelpers'
import WebSocketStore from 'core/classes/services/WebSocketStore'
import { WebSocketClient } from 'core/classes/ws/WebSocketClient'
import { Crud } from 'core/types/Crud'
import { CrudInnerStorageFetcher } from 'core/types/CrudInnerStorageFetcher'
import { CrudStore } from 'core/types/crudStore'
import { ProcedureInnerStorageFetcher } from 'core/types/ProcedureInnerStorageFetcher'
import Logger from 'core/utils/Logger'
import { IPbmListItem } from 'partner360/components/filters/pbmMultiselect'
import { IP360Ticket } from 'partner360/models/p360Ticket'
import { IQBRForm1554 } from 'partner360/models/qbr/IQBRForm1554'
import { callSobTrendsPartnerSearchFromCrud } from 'partner360/services/sobTrends/callSobTrendsPartnerSearchFromCrud'
import { fetchGlobalPartners, fetchPartnersToAdd } from 'partner360/widgets/gp360Administration'
import { fetchGlobalPartnerDetails } from 'partner360/widgets/gp360Administration/components/globalPartnerTable/api/fetchGlobalPartnerDetails'
import { fetchGPLongTermsRollup } from 'partner360/widgets/longTermGoals'
import settings from 'src/config/settings'

import { fetchJBPBridges } from '../../../components/widgets/public/partner360/actionsPlan/commercialBridges/components/businessBridges/api/fetchJBPBridges'
import { getFetchJbpFilters } from '../../../components/widgets/public/partner360/actionsPlan/commercialBridges/components/businessBridges/helpers/getFetchJbpFilters'
import { IFormSwotData } from '../../../components/widgets/public/partner360/swotAnalysis/models/iFormSwotData'
import { IBridge } from '../../models/partner360/IBridge'
import { IFormActualsByOffering } from '../../models/partner360/IFormActualsByOffering'
import { IFormActualsTargetsSettings } from '../../models/partner360/IFormActualsTargetsSettings'
import { IFormBasicInfo } from '../../models/partner360/IFormBasicInfo'
import { IFormCountryManagerSummaryDistributors } from '../../models/partner360/IFormCountryManagerSummaryDistributors'
import { IFormCountryManagerSummaryRetailers } from '../../models/partner360/IFormCountryManagerSummaryRetailers'
import { IFormCreditStatusInfo } from '../../models/partner360/IFormCreditStatusInfo'
import { IFormDigitalAssessment } from '../../models/partner360/IFormDigitalAssessment'
import { IFormDistributorBridges } from '../../models/partner360/IFormDistributorBridges'
import { IFormDistributorGroup } from '../../models/partner360/IFormDistributorGroup'
import { IFormDistributorInventory } from '../../models/partner360/IFormDistributorInventory'
import { IFormDistributorInventoryAmbition } from '../../models/partner360/IFormDistributorInventoryAmbition'
import { IFormDistributorScopeDetails } from '../../models/partner360/IFormDistributorScopeDetails'
import { IFormDistributorScopeSummary } from '../../models/partner360/IFormDistributorScopeSummary'
import { IFormJBPPartnerDataDynamic } from '../../models/partner360/IFormJBPPartnerDataDynamic'
import { IFormJBPPBMManagers } from '../../models/partner360/IFormJBPPBMManagers'
import { IFormJBPReportType } from '../../models/partner360/IFormJBPReportType'
import { IFormJBPRetailMarketInfo } from '../../models/partner360/IFormJBPRetailMarketInfo'
import { IFormMarketDeepDive } from '../../models/partner360/IFormMarketDeepDive'
import { IFormNdpRate } from '../../models/partner360/IFormNdpRate'
import { IFormOfferings } from '../../models/partner360/IFormOfferings'
import { IFormPartner360Attachments } from '../../models/partner360/IFormPartner360Attachments'
import { IFormPartner360Statistics } from '../../models/partner360/IFormPartner360Statistics'
import { IFormPBMManagers } from '../../models/partner360/IFormPBMManagers'
import { IFormRetailGroup } from '../../models/partner360/IFormRetailGroup'
import { IFormSalesTeamSRM } from '../../models/partner360/IFormSalesTeamSRM'
import { IFormShareOfBusiness } from '../../models/partner360/IFormShareOfBusiness'
import { IFormSoBData } from '../../models/partner360/IFormSoBData'
import { IFormTargetsByOffering } from '../../models/partner360/IFormTargetsByOffering'
import { IFormTopPartnerSummaryReport } from '../../models/partner360/IFormTopPartnerSummaryReport'
import { IFormTTAFormatType } from '../../models/partner360/IFormTTAFormatType'
import { CrudConnectorsPartner360 } from '../CrudConnectorsPartner360'

class InitializationServicePartner360 {
  private static initialized = false

  public init = () => {
    if (settings.partner360Service?.wsServer && !WebSocketStore.has('partner360')) {
      const wsClient = new WebSocketClient()
      wsClient.init(settings.partner360Service.wsServer).catch(Logger.error)
      WebSocketStore.add(wsClient, 'partner360')
    }

    CrudStore.add(
      new Crud<IFormPartnerDevicesInfo>({
        fetcher: new CrudInnerStorageFetcher<IFormPartnerDevicesInfo>('EntryId', {
          formId: 612,
          code: 'CompensationScheme',
        }),
        keyField: 'PartnerID',
      }),
      CrudStoreItemPartner360.PartnerDevicesInfo
    )
    CrudStore.add(
      new Crud<IFormPartnerMarketInfo>({
        fetcher: new CrudInnerStorageFetcher<IFormPartnerMarketInfo>('EntryId', {
          formId: 613,
          code: 'BPCommitmentInfo',
        }),
        keyField: 'PartnerID',
      }),
      CrudStoreItemPartner360.PartnerMarketInfo
    )
    CrudStore.add(
      new Crud<IFormPartnerMarketLeasing>({
        fetcher: new CrudInnerStorageFetcher<IFormPartnerMarketLeasing>('EntryId', {
          formId: 1018,
          code: 'JBPMarketLeasing',
        }),
        keyField: 'EntryId',
      }),
      CrudStoreItemPartner360.PartnerMarketLeasing
    )
    CrudStore.add(
      new Crud<IFormProgramsManagementAdmin>({
        fetcher: new CrudInnerStorageFetcher<IFormProgramsManagementAdmin>('EntryId', {
          formId: 614,
          code: 'JBPProgramManagement',
        }),
        keyField: 'EntryId',
        defaultSort: { field: 'CategoryName', dir: 'asc' },
      }),
      CrudStoreItemPartner360.ProgramsManagementAdmin
    )
    CrudStore.add(
      new Crud<IFormProgramsManagementPartner>({
        fetcher: new CrudInnerStorageFetcher<IFormProgramsManagementPartner>('EntryId', {
          formId: 615,
          code: 'ProgramsManagementPartner',
        }),
        keyField: 'PartnerID',
      }),
      CrudStoreItemPartner360.ProgramsManagementPartner
    )
    CrudStore.add(
      new Crud<IFormPartnerBasicInfo>({
        fetcher: new CrudInnerStorageFetcher<IFormPartnerBasicInfo>('UniqueId', {
          formId: 621,
          code: 'JBPPartnerData',
        }),
        keyField: 'UniqueId',
      }),
      CrudStoreItemPartner360.PartnerBasicInfo
    )
    CrudStore.add(
      new Crud<IFormBasicInfo>({
        fetcher: new CrudInnerStorageFetcher<IFormBasicInfo>('EntryId', {
          formId: 1091,
          code: 'jbp-basicinfo-1091',
        }),
        keyField: 'EntryId',
      }),
      CrudStoreItemPartner360.JBPBasicInfo
    )
    CrudStore.add(
      new Crud<IFormCreditStatusInfo>({
        fetcher: new CrudInnerStorageFetcher<IFormCreditStatusInfo>('EntryId', {
          formId: 1082,
          code: 'JBPCreditStatusInfo',
        }),
        keyField: 'EntryId',
      }),
      CrudStoreItemPartner360.JBPCreditStatusInfo
    )
    CrudStore.add(
      new Crud<IFormMarketShare>({
        fetcher: new CrudInnerStorageFetcher<IFormMarketShare>('EntryId', {
          formId: 1063,
          code: 'JBPMarketShare',
        }),
        keyField: 'EntryId',
      }),
      CrudStoreItemPartner360.JBPMarketShare
    )
    CrudStore.add(
      new Crud<IJBPDataInsight>({
        fetcher: new CrudInnerStorageFetcher<IJBPDataInsight>('EntryId', {
          formId: 1159,
          code: 'data-insight-1159',
        }),
        keyField: 'EntryId',
        defaultPaging: { page: 0, pageSize: 10000 },
      }),
      CrudStoreItemPartner360.JBPDataInsight
    )
    CrudStore.add(
      new Crud<IForm3rdPartySolutions>({
        fetcher: new CrudInnerStorageFetcher<IForm3rdPartySolutions>('EntryId', {
          formId: 628,
          code: 'JBPThirdPartySolutions',
        }),
        keyField: 'EntryId',
        defaultPaging: { page: 0, pageSize: 5 },
      }),
      CrudStoreItemPartner360.ThirdPartySolutions
    )
    CrudStore.add(
      new Crud<IFormActionsPlan>({
        fetcher: new CrudInnerStorageFetcher<IFormActionsPlan>('EntryId', {
          formId: 625,
          code: 'JBPActionsPlan',
        }),
        keyField: 'EntryId',
        defaultSort: { field: 'ActionType', dir: 'asc' },
        defaultPaging: { page: 0, pageSize: 5 },
      }),
      CrudStoreItemPartner360.ActionsPlan
    )
    CrudStore.add(
      new Crud<IFormCompensation>({
        fetcher: new CrudInnerStorageFetcher<IFormCompensation>('UniqueId', {
          formId: 612,
          code: 'JBPCompensationSettings',
        }),
        keyField: 'UniqueId',
        defaultSort: [
          { field: 'CategoryOrder', dir: 'asc' },
          { field: 'SubCategoryOrder', dir: 'asc' },
        ],
        defaultPaging: { page: 0, pageSize: 100 },
      }),
      CrudStoreItemPartner360.CompensationScheme
    )
    CrudStore.add(
      new Crud<IFormPartnerSales>({
        fetcher: new CrudInnerStorageFetcher<IFormPartnerSales>('EntryId', {
          formId: 629,
          code: 'JBPPartnerSales',
        }),
        keyField: 'EntryId',
        defaultSort: { field: 'EntryId', dir: 'desc' },
        defaultPaging: { page: 0, pageSize: 10000 },
      }),
      CrudStoreItemPartner360.PartnerSales
    )
    CrudStore.add(
      new Crud<IFormPartnerSales>({
        fetcher: new CrudInnerStorageFetcher<any>('UniqueId', {
          formId: 629,
          code: 'JBPMIFActuals',
        }),
        keyField: 'UniqueId',
        defaultPaging: { page: 0, pageSize: 100 },
      }),
      CrudStoreItemPartner360.JBPMIFActuals
    )
    CrudStore.add(
      new Crud<IFormPartnerSalesScheme>({
        fetcher: new CrudInnerStorageFetcher<IFormPartnerSalesScheme>('UniqueId', {
          formId: 629,
          code: 'JBPActualsNdp',
        }),
        keyField: 'UniqueId',
        defaultPaging: { page: 0, pageSize: 10000 },
      }),
      CrudStoreItemPartner360.PartnerSalesScheme
    )
    CrudStore.add(
      new Crud<IFormPartnerTargets>({
        fetcher: new CrudInnerStorageFetcher<IFormPartnerTargets>('EntryId', {
          formId: 630,
          code: 'JBPTargetsNdp',
        }),
        keyField: 'EntryId',
        defaultSort: { field: 'EntryId', dir: 'desc' },
        defaultPaging: { page: 0, pageSize: 10000 },
      }),
      CrudStoreItemPartner360.PartnerTargets
    )
    CrudStore.add(
      new Crud<IFormGeneralPlanning>({
        fetcher: new CrudInnerStorageFetcher<IFormGeneralPlanning>('UniqueId', {
          formId: 630,
          code: 'JBPGeneralPlanningNdp',
        }),
        keyField: 'UniqueId',
      }),
      CrudStoreItemPartner360.GeneralPlanning
    )
    CrudStore.add(
      new Crud<IFormDaaSPlanActuals>({
        fetcher: new CrudInnerStorageFetcher<IFormDaaSPlanActuals>('UniqueId', {
          formId: 791,
          code: 'JBPDaaSCustomerSales',
        }),
        keyField: 'UniqueId',
      }),
      CrudStoreItemPartner360.DaaSPlanActuals
    )
    CrudStore.add(
      new Crud<PSEndCustomer>({
        fetcher: new CrudInnerStorageFetcher<PSEndCustomer>('EndCustomerName', {
          formId: 791,
          code: 'JBPDaaSCustomers',
        }),
        keyField: 'EndCustomerName',
        defaultPaging: { page: 0, pageSize: 1000 },
      }),
      CrudStoreItemPartner360.PSEndCustomers
    )
    CrudStore.add(
      new Crud<IFormCommitment>({
        fetcher: new CrudInnerStorageFetcher<IFormCommitment>('EntryId', {
          formId: 613,
          code: 'BPCommitmentInfo',
        }),
        keyField: 'EntryId',
        defaultSort: { field: 'EntryId', dir: 'desc' },
      }),
      CrudStoreItemPartner360.Commitment
    )
    CrudStore.add(
      new Crud<IFormCommitmentHistory>({
        fetcher: new CrudInnerStorageFetcher<IFormCommitmentHistory>('EntryId', {
          formId: 613,
          code: 'JBPCommitmentLogView',
        }),
        keyField: 'EntryId',
        defaultSort: { field: 'ActionDate', dir: 'desc' },
        defaultPaging: { page: 0, pageSize: 10 },
      }),
      CrudStoreItemPartner360.JBPCommitmentLogView
    )
    CrudStore.add(
      new Crud<IFormLookupTool>({
        fetcher: new CrudInnerStorageFetcher<IFormLookupTool>('EntryId', {
          formId: 606,
          code: 'WW_SalesTeam',
        }),
        keyField: 'EntryId',
        defaultSort: { field: 'EntryId', dir: 'desc' },
      }),
      CrudStoreItemPartner360.LookupTool
    )
    CrudStore.add(
      new Crud<IFormOptionsJBP>({
        fetcher: new CrudInnerStorageFetcher<IFormOptionsJBP>('EntryId', {
          formId: 590,
          code: 'JBPSettings',
        }),
        keyField: 'EntryId',
        defaultSort: { field: 'EntryId', dir: 'desc' },
      }),
      CrudStoreItemPartner360.JBPSettings
    )

    CrudStore.add(
      new Crud<{ PartnerId: string; Mappings: string }, string>({
        fetcher: new CrudInnerStorageFetcher('PartnerId', {
          formId: 590,
          code: 'JBPExportMappings',
        }),
        keyField: 'PartnerId',
      }),
      CrudStoreItemPartner360.JBPExportMappings
    )
    CrudStore.add(
      new Crud<IFormCompleteness>({
        fetcher: new Static([] as IFormCompleteness[]),
        keyField: 'partnerId',
      }),
      CrudStoreItemPartner360.CompletenessJBP
    )
    CrudStore.add(
      new Crud<IFormThingsToImprove>({
        fetcher: new CrudInnerStorageFetcher<IFormThingsToImprove>('EntryId', {
          formId: 696,
          code: 'DaaSPRateTargets',
        }),
        keyField: 'EntryId',
        defaultPaging: { page: 0, pageSize: 5 },
      }),
      CrudStoreItemPartner360.JBPThingsToImprove
    )
    CrudStore.add(
      new Crud({
        fetcher: new CrudInnerStorageFetcher('Id', {
          formId: 74,
          code: 'JBPGeoMapping',
        }),
        keyField: 'Id',
        defaultPaging: {
          page: 0,
          pageSize: 1000,
        },
      }),
      CrudStoreItemPartner360.GeoMapping
    )
    CrudStore.add(
      new Crud({
        fetcher: new CrudInnerStorageFetcher('UniqueId', {
          formId: 951,
          code: 'JBPProductsTree',
        }),
        keyField: 'UniqueId',
        defaultPaging: {
          page: 0,
          pageSize: 1000,
        },
      }),
      CrudStoreItemPartner360.JBPProductsTree
    )
    CrudStore.add(
      new Crud<IFormPartnerContacts>({
        fetcher: new CrudInnerStorageFetcher<IFormPartnerContacts>('EntryId', {
          formId: 700,
          code: 'JBPPartnerContacts',
        }),
        keyField: 'EntryId',
        defaultSort: { field: 'EntryId', dir: 'desc' },
        defaultPaging: { page: 0, pageSize: 5 },
      }),
      CrudStoreItemPartner360.PartnerContacts
    )
    CrudStore.add(
      new Crud<IFormPartnerContacts>({
        fetcher: new CrudInnerStorageFetcher<IFormPartnerContacts>('ContactId', {
          formId: 700,
          code: 'JBPPartnerContactsHierarchy',
        }),
        keyField: 'ContactId',
        defaultPaging: { page: 0, pageSize: 1000 },
      }),
      CrudStoreItemPartner360.JBPPartnerContactsHierarchy
    )
    CrudStore.add(
      new Crud<IFormMIFCompensation>({
        fetcher: new CrudInnerStorageFetcher<IFormMIFCompensation>('PartnerId', {
          formId: 630,
          code: 'JBPMIFCompensation',
        }),
        keyField: 'PartnerId',
      }),
      CrudStoreItemPartner360.MIFCompensation
    )
    CrudStore.add(
      new Crud<IFormHistoricalResults>({
        fetcher: new CrudInnerStorageFetcher<IFormHistoricalResults>('UniqueId', {
          formId: 590,
          code: 'JBPSalesNdp',
        }),
        keyField: 'UniqueId',
        defaultSort: { field: 'SalesYear', dir: 'asc' },
        defaultPaging: { page: 0, pageSize: 10000 },
      }),
      CrudStoreItemPartner360.JBPSales
    )
    CrudStore.add(
      new Crud<IFormActualsAndPlans>({
        fetcher: new CrudInnerStorageFetcher<IFormActualsAndPlans>('UniqueId', {
          formId: 630,
          code: 'JBPActuals',
        }),
        keyField: 'UniqueId',
        defaultPaging: { page: 0, pageSize: 10 },
      }),
      CrudStoreItemPartner360.JBPActuals
    )
    CrudStore.add(
      new Crud<IFormActualsByOffering>({
        fetcher: new CrudInnerStorageFetcher<IFormActualsByOffering>('UniqueId', {
          formId: 621,
          code: 'JBPActualsByOffering',
        }),
        keyField: 'UniqueId',
        defaultPaging: { page: 0, pageSize: 10000 },
      }),
      CrudStoreItemPartner360.JBPActualsByOffering
    )
    CrudStore.add(
      new Crud<IFormTargetsByOffering>({
        fetcher: new CrudInnerStorageFetcher<IFormTargetsByOffering>('UniqueId', {
          formId: 621,
          code: 'JBPTargetsByOffering',
        }),
        keyField: 'UniqueId',
        defaultPaging: { page: 0, pageSize: 10000 },
      }),
      CrudStoreItemPartner360.JBPTargetsByOffering
    )
    CrudStore.add(
      new Crud<IFormTargetsByOfferingV2>({
        fetcher: new CrudInnerStorageFetcher<IFormTargetsByOfferingV2>('UniqueId', {
          formId: 630,
          code: 'JBPTargetsByOfferingV2',
        }),
        keyField: 'UniqueId',
        defaultPaging: { page: 0, pageSize: 10000 },
      }),
      CrudStoreItemPartner360.JBPTargetsByOfferingV2
    )
    CrudStore.add(
      new Crud<ITranslationFactors>({
        fetcher: new CrudInnerStorageFetcher<ITranslationFactors>('EntryId', {
          formId: 1296,
          code: 'JBPTranslationFactors',
        }),
        keyField: 'EntryId',
        defaultPaging: { page: 0, pageSize: 20 },
      }),
      CrudStoreItemPartner360.JBPTranslationFactors
    )
    CrudStore.add(
      new Crud<IFormActualsAndPlans>({
        fetcher: new CrudInnerStorageFetcher<IFormActualsAndPlans>('UniqueId', {
          formId: 630,
          code: 'JBPActualsAndPlans',
        }),
        keyField: 'UniqueId',
        defaultPaging: { page: 0, pageSize: 100000 },
      }),
      CrudStoreItemPartner360.JBPActualsAndPlans
    )
    CrudStore.add(
      new Crud({
        fetcher: new CrudInnerStorageFetcher('Category', {
          formId: 951,
          code: 'JBPActualsAndTargetsCategories',
        }),
        keyField: 'Category',
        defaultPaging: {
          page: 0,
          pageSize: 100,
        },
      }),
      CrudStoreItemPartner360.JBPActualsAndTargetsCategories
    )
    CrudStore.add(
      new Crud<IFormHPContacts>({
        fetcher: new CrudInnerStorageFetcher<IFormHPContacts>('EntryId', {
          formId: 606,
          code: 'WW_SalesTeam',
        }),
        keyField: 'EntryId',
        defaultSort: { field: 'EntryId', dir: 'desc' },
      }),
      CrudStoreItemPartner360.HPContacts
    )
    CrudStore.add(
      new Crud<IFormJBPSalesTeam>({
        fetcher: new CrudInnerStorageFetcher<IFormJBPSalesTeam>('EntryId', {
          formId: 621,
          code: 'JBPSalesTeam',
        }),
        keyField: 'EntryId',
        defaultPaging: { page: 0, pageSize: 10 },
        defaultSort: { field: 'EntryId', dir: 'desc' },
      }),
      CrudStoreItemPartner360.JBPSalesTeam
    )
    CrudStore.add(
      new Crud<IFormJBPHPContactChangeRequest>({
        fetcher: new CrudInnerStorageFetcher<IFormJBPHPContactChangeRequest>('EntryId', {
          formId: 1217,
          code: 'JBPHPContactChangeRequest',
        }),
        keyField: 'EntryId',
        defaultPaging: { page: 0, pageSize: 10 },
        defaultSort: { field: 'EntryId', dir: 'desc' },
      }),
      CrudStoreItemPartner360.JBPHPContactChangeRequest
    )
    CrudStore.add(
      new Crud({
        fetcher: new CrudInnerStorageFetcher<any>('Id', {
          formId: 757,
          code: 'JBPProductLines',
        }),
        keyField: 'Id',
        defaultPaging: {
          page: 0,
          pageSize: 1000,
        },
      }),
      CrudStoreItemPartner360.JBPProductLines
    )
    CrudStore.add(
      new Crud<IFormJBPHPContactRoles>({
        fetcher: new CrudInnerStorageFetcher<IFormJBPHPContactRoles>('UniqueId', {
          formId: 1217,
          code: 'JBPHPContactRoles',
        }),
        keyField: 'UniqueId',
        defaultPaging: { page: 0, pageSize: 100 },
        defaultSort: { field: 'Roles', dir: 'desc' },
      }),
      CrudStoreItemPartner360.JBPHPContactRoles
    )
    CrudStore.add(
      new Crud<IHpContactManagement>({
        fetcher: new CrudInnerStorageFetcher<IHpContactManagement>('EntryId', {
          formId: 606,
          code: 'WW_SalesTeamPBMsList',
        }),
        keyField: 'EntryId',
        defaultSort: { field: 'EntryId', dir: 'desc' },
      }),
      CrudStoreItemPartner360.SalesTeamMngm
    )
    CrudStore.add(
      new Crud<IFormSalesTeamRequest>({
        fetcher: new CrudInnerStorageFetcher<IFormSalesTeamRequest>('EntryId', {
          formId: 886,
          code: 'SalesTeamRequests',
        }),
        keyField: 'EntryId',
        defaultSort: { field: 'EntryId', dir: 'desc' },
      }),
      CrudStoreItemPartner360.SalesTeamRequests
    )
    CrudStore.add(
      new Crud<IFormHPContacts>({
        fetcher: new CrudInnerStorageFetcher<IFormHPContacts>('EntryId', {
          formId: 871,
          code: 'sales-team-master-data-871',
        }),
        keyField: 'EntryId',
        defaultSort: { field: 'EntryId', dir: 'desc' },
      }),
      CrudStoreItemPartner360.SalesTeamSRM
    )
    CrudStore.add(
      new Crud<IFormSalesTeamSRM>({
        fetcher: new CrudInnerStorageFetcher<IFormSalesTeamSRM>('EntryId', {
          formId: 871,
          code: 'SalesTeamSRM',
        }),
        keyField: 'EntryId',
        defaultSort: { field: 'EntryId', dir: 'desc' },
      }),
      CrudStoreItemPartner360.SalesTeamSRMData
    )
    CrudStore.add(
      new Crud<IFormHPContacts>({
        fetcher: new CrudInnerStorageFetcher<IFormHPContacts>('EntryId', {
          formId: 774,
          code: 'SalesTeamImportView',
        }),
        keyField: 'EntryId',
        defaultSort: { field: 'EntryId', dir: 'desc' },
      }),
      CrudStoreItemPartner360.SalesTeamImport
    )
    CrudStore.add(
      new Crud<{ key: string; value: string }>({
        fetcher: new Static([] as { key: string; value: string }[]),
        keyField: 'key',
      }),
      CrudStoreItemPartner360.SalesTeamFilters
    )
    CrudStore.add(
      new Crud<IFormPartnerMasterDealer>({
        fetcher: new CrudInnerStorageFetcher<IFormPartnerMasterDealer>('EntryId', {
          formId: 740,
          code: 'JBPMasterDealerData',
        }),
        keyField: 'EntryId',
        defaultSort: { field: 'EntryId', dir: 'desc' },
      }),
      CrudStoreItemPartner360.PartnerMasterDealer
    )
    CrudStore.add(
      new Crud<IFormTopPartnersDetails>({
        fetcher: new ProcedureInnerStorageFetcher<IFormTopPartnersDetails>('PartnerId', {
          readFromTo: async (filter, sort, paging) =>
            await PartnerDetailsApi.fetchTopPartnersDetails(filter, paging),
        }),
        keyField: 'PartnerId',
        defaultPaging: { page: 0, pageSize: 5 },
      }),
      CrudStoreItemPartner360.TopPartnerSummary
    )
    CrudStore.add(
      new Crud<IForm>({
        fetcher: new ProcedureInnerStorageFetcher<IForm>('EntryId', {
          readFromTo: async (filter) =>
            await partnerManagementApi.fetchPartnerProgramsDetails(filter),
        }),
        keyField: 'EntryId',
      }),
      CrudStoreItemPartner360.JBPProgramsManagementPartner
    )
    CrudStore.add(
      new Crud<IFormPartnerDaasSummary>({
        fetcher: new CrudInnerStorageFetcher<IFormPartnerDaasSummary>('UniqueId', {
          formId: 630,
          code: 'JBPDaaSPlanSummaryNdp',
        }),
        keyField: 'UniqueId',
      }),
      CrudStoreItemPartner360.JBPDaasSummary
    )
    CrudStore.add(
      new Crud<IFormTopTargetAccounts>({
        fetcher: new CrudInnerStorageFetcher<IFormTopTargetAccounts>('EntryId', {
          formId: 743,
          code: 'JBPTopTargetAccounts',
        }),
        keyField: 'EntryId',
        defaultPaging: { page: 0, pageSize: 5 },
      }),
      CrudStoreItemPartner360.JBPTopTargetAccounts
    )
    CrudStore.add(
      new Crud<{
        EntryId: number
        PartnerId: string
        EmailTo: string
        NotificationSendLog: string
      }>({
        fetcher: new CrudInnerStorageFetcher('EntryId', {
          formId: 755,
          code: 'MasterDealerMailing',
        }),
        keyField: 'EntryId',
      }),
      CrudStoreItemPartner360.MasterDealerMailing
    )
    CrudStore.add(
      new Crud({
        fetcher: new Static<ICachedProgramType[]>([]),
        keyField: 'partnerId',
      }),
      CrudStoreItemPartner360.ProgramTypeCacheStore
    )
    CrudStore.add(
      new Crud<IHistoricalResultsChartOptions>({
        fetcher: new Static([] as IHistoricalResultsChartOptions[]),
        keyField: 'key',
      }),
      CrudStoreItemPartner360.HistoricalResultsChartOptions
    )
    CrudStore.add(
      new Crud<IFormMPSDetails>({
        fetcher: new ProcedureInnerStorageFetcher<IFormMPSDetails>('PartnerId', {
          readFromTo: async (filter, sort, paging) =>
            await MPSSummaryApi.fetchMPSDetails(filter, paging),
        }),
        keyField: 'PartnerId',
        defaultPaging: { page: 0, pageSize: 5 },
      }),
      CrudStoreItemPartner360.MPSSummary
    )
    CrudStore.add(
      new Crud<IFormCountryManagerSummary>({
        fetcher: new CrudInnerStorageFetcher<IFormCountryManagerSummary>('UniqueId', {
          formId: 621,
          code: 'JBPCountryManagerApproval',
        }),
        defaultPaging: {
          page: 0,
          pageSize: 10,
        },
        keyField: 'UniqueId',
      }),
      CrudStoreItemPartner360.CountryManagerSummary
    )
    CrudStore.add(
      new Crud<IFormCountryManagerSummaryDistributors>({
        fetcher: new CrudInnerStorageFetcher<IFormCountryManagerSummaryDistributors>('PartnerId', {
          formId: 621,
          code: 'JBPDistiManagerApproval',
        }),
        defaultPaging: { page: 0, pageSize: 10 },
        keyField: 'PartnerId',
      }),
      CrudStoreItemPartner360.CountryManagerSummaryDistributors
    )
    CrudStore.add(
      new Crud<IFormCountryManagerSummaryRetailers>({
        fetcher: new CrudInnerStorageFetcher<IFormCountryManagerSummaryRetailers>('PartnerId', {
          formId: 621,
          code: 'JBPRetailManagerApproval',
        }),
        defaultPaging: { page: 0, pageSize: 10 },
        keyField: 'PartnerId',
      }),
      CrudStoreItemPartner360.CountryManagerSummaryRetailers
    )
    CrudStore.add(
      new Crud<IFormExceptionalPartnerSpecialization>({
        fetcher: new CrudInnerStorageFetcher<IFormExceptionalPartnerSpecialization>('EntryId', {
          formId: 766,
          code: 'JBPExceptionalPartnerSpecialization',
        }),
        keyField: 'EntryId',
      }),
      CrudStoreItemPartner360.ExceptionalPartnerSpecialization
    )
    CrudStore.add(
      new Crud<IFormPBMList>({
        fetcher: new CrudInnerStorageFetcher<IFormPBMList>('Email', {
          formId: 621,
          code: 'JBPPBMList',
        }),
        keyField: 'Email',
        defaultSort: { field: 'Name', dir: 'asc' },
        defaultPaging: { page: 0, pageSize: 100 },
      }),
      CrudStoreItemPartner360.PBMList
    )
    CrudStore.add(
      new Crud<IFormActionsPlanMDF>({
        fetcher: new CrudInnerStorageFetcher<IFormActionsPlanMDF>('EntryId', {
          formId: 625,
          code: 'JBPDistributorActionsPlan',
        }),
        keyField: 'EntryId',
        defaultSort: { field: 'Activity', dir: 'asc' },
      }),
      CrudStoreItemPartner360.JBPDistributorActionsPlan
    )
    CrudStore.add(
      new Crud<IFormActionsPlanMDF>({
        fetcher: new CrudInnerStorageFetcher<IFormActionsPlanMDF>('EntryId', {
          formId: 625,
          code: 'JBPActionPlanMDF',
        }),
        keyField: 'EntryId',
        defaultSort: { field: 'Activity', dir: 'asc' },
        defaultPaging: { page: 0, pageSize: 5 },
      }),
      CrudStoreItemPartner360.ActionsPlanMDF
    )
    CrudStore.add(
      new Crud<IFormActionsPlanMDFFYears>({
        fetcher: new CrudInnerStorageFetcher<IFormActionsPlanMDFFYears>('UniqueId', {
          formId: 625,
          code: 'JBPActionPlanMDFFYears',
        }),
        keyField: 'UniqueId',
        defaultSort: { field: 'FYear', dir: 'desc' },
        defaultPaging: { page: 0, pageSize: 1000 },
      }),
      CrudStoreItemPartner360.ActionsPlanMDFFYears
    )
    CrudStore.add(
      new Crud<IFormJBPRetailMarketInfo>({
        fetcher: new CrudInnerStorageFetcher<IFormJBPRetailMarketInfo>('EntryId', {
          formId: 1124,
          code: 'JBPRetailMarketInfo',
        }),
        keyField: 'EntryId',
      }),
      CrudStoreItemPartner360.JBPRetailMarketInfo
    )
    CrudStore.add(
      new Crud({
        fetcher: new CrudInnerStorageFetcher('PartnerId', {
          formId: 679,
          code: 'JBPCommercialCompletenessData',
        }),
        keyField: 'PartnerId',
      }),
      CrudStoreItemPartner360.JBPCommercialCompletenessData
    )
    CrudStore.add(
      new Crud({
        fetcher: new CrudInnerStorageFetcher('UniqueId', {
          formId: 679,
          code: 'JBPCommercialCompletenessDataByPBM',
        }),
        keyField: 'UniqueId',
        defaultPaging: {
          page: 0,
          pageSize: 1,
        },
      }),
      CrudStoreItemPartner360.JBPCommercialCompletenessDataByPBM
    )
    CrudStore.add(
      new Crud<IFormPartnerMasterDealerReport>({
        fetcher: new CrudInnerStorageFetcher<IFormPartnerMasterDealerReport>('UniqueId', {
          formId: 740,
          code: 'JBPMasterDealerData',
        }),
        keyField: 'UniqueId',
      }),
      CrudStoreItemPartner360.MasterDealerReport
    )
    CrudStore.add(
      new Crud<IFormExtendedPartnerTCAcceptanceReport>({
        fetcher: new CrudInnerStorageFetcher<IFormExtendedPartnerTCAcceptanceReport>('UniqueId', {
          formId: 740,
          code: 'JBPExtendedPartnerTCAcceptanceReport',
        }),
        keyField: 'UniqueId',
      }),
      CrudStoreItemPartner360.JBPExtendedPartnerTCAcceptanceReport
    )
    CrudStore.add(
      new Crud({
        fetcher: new ProcedureInnerStorageFetcher('EntryId', {
          readFromTo: async (filter) => await fetchKeyInitiatives(filter),
        }),
        keyField: 'EntryId',
        skipPagingTransform: true,
      }),
      CrudStoreItemPartner360.JBPSPKeyInitiatives
    )
    CrudStore.add(
      new Crud<IFormThingsToImprove>({
        fetcher: new CrudInnerStorageFetcher<IFormThingsToImprove>('EntryId', {
          formId: 801,
          code: 'JBPKeyInitiatives',
        }),
        keyField: 'EntryId',
      }),
      CrudStoreItemPartner360.JBPKeyInitiatives
    )
    CrudStore.add(
      new Crud<IFormMasterDealerBlockedPartners>({
        fetcher: new CrudInnerStorageFetcher<IFormMasterDealerBlockedPartners>('PartnerId', {
          formId: 740,
          code: 'JBPMasterDealerBlockedPartners',
        }),
        keyField: 'PartnerId',
      }),
      CrudStoreItemPartner360.JBPMasterDealerBlockedPartners
    )
    CrudStore.add(
      new Crud<IFormBPExportFiles>({
        fetcher: new CrudInnerStorageFetcher<IFormBPExportFiles>('UniqueId', {
          formId: 621,
          code: 'JBPBPExportFiles',
        }),
        keyField: 'UniqueId',
      }),
      CrudStoreItemPartner360.JBPBPExportFiles
    )
    CrudStore.add(
      new Crud<IFormSummaryAchievements>({
        fetcher: new CrudInnerStorageFetcher<IFormSummaryAchievements>('EntryId', {
          formId: 822,
          code: 'JBPSummaryAndAchivements',
        }),
        keyField: 'EntryId',
      }),
      CrudStoreItemPartner360.JBPSummaryAndAchivements
    )
    CrudStore.add(
      new Crud<IFormPartnerShareOfBusiness>({
        fetcher: new CrudInnerStorageFetcher<IFormPartnerShareOfBusiness>('EntryId', {
          formId: 826,
          code: 'JBPShareOfBusiness',
        }),
        keyField: 'EntryId',
      }),
      CrudStoreItemPartner360.JBPShareOfBusiness
    )
    CrudStore.add(
      new Crud<IFormShareOfBusiness>({
        fetcher: new CrudInnerStorageFetcher<IFormShareOfBusiness>('UniqueId', {
          formId: 1221,
          code: 'JBPHPPartnerShareOfBusiness',
        }),
        keyField: 'UniqueId',
      }),
      CrudStoreItemPartner360.JBPHPPartnerShareOfBusiness
    )
    CrudStore.add(
      new Crud<IFormSoBData>({
        fetcher: new CrudInnerStorageFetcher<IFormSoBData>('UniqueId', {
          formId: 1266,
          code: 'JBPSoBData',
        }),
        keyField: 'UniqueId',
      }),
      CrudStoreItemPartner360.JBPSoBData
    )
    CrudStore.add(
      new Crud<IFormActionCapabilities>({
        fetcher: new CrudInnerStorageFetcher<IFormActionCapabilities>('EntryId', {
          formId: 830,
          code: 'JBPActionCapabilities',
        }),
        keyField: 'EntryId',
      }),
      CrudStoreItemPartner360.JBPActionCapabilities
    )
    CrudStore.add(
      new Crud<IFormMIFReport>({
        fetcher: new CrudInnerStorageFetcher<IFormMIFReport>('UniqueId', {
          formId: 625,
          code: 'JBPTargetsMIFExport',
        }),
        keyField: 'UniqueId',
      }),
      CrudStoreItemPartner360.JBPTargetsMIFExport
    )
    CrudStore.add(
      new Crud<IFormMIFReport>({
        fetcher: new CrudInnerStorageFetcher<IFormMIFReport>('UniqueId', {
          formId: 625,
          code: 'JBPTargetsMIFExport',
        }),
        keyField: 'UniqueId',
      }),
      CrudStoreItemPartner360.JBPTargetsMIFExport
    )
    CrudStore.add(
      new Crud<IFormDistributorGroup>({
        fetcher: new CrudInnerStorageFetcher<IFormDistributorGroup>('EntryId', {
          formId: 1149,
          code: 'JBPDistributorGroup',
        }),
        keyField: 'EntryId',
        defaultPaging: { page: 0, pageSize: 100 },
      }),
      CrudStoreItemPartner360.JBPDistributorGroup
    )
    CrudStore.add(
      new Crud<IFormRetailGroup>({
        fetcher: new CrudInnerStorageFetcher<IFormRetailGroup>('EntryId', {
          formId: 1175,
          code: 'JBPRetailGroup',
        }),
        keyField: 'EntryId',
        defaultPaging: { page: 0, pageSize: 100 },
      }),
      CrudStoreItemPartner360.JBPRetailGroup
    )
    CrudStore.add(
      new Crud<IFormDistributorScope>({
        fetcher: new CrudInnerStorageFetcher<IFormDistributorScope>('EntryId', {
          formId: 1149,
          code: 'distributors-scope-1149',
        }),
        keyField: 'EntryId',
        defaultPaging: { page: 0, pageSize: 100 },
      }),
      CrudStoreItemPartner360.JBPDistributorScope
    )
    CrudStore.add(
      new Crud<IFormDistributorScopeData>({
        fetcher: new CrudInnerStorageFetcher<IFormDistributorScopeData>('UniqueId', {
          formId: 625,
          code: 'JBPDistributorScopeData',
        }),
        keyField: 'UniqueId',
        defaultPaging: { page: 0, pageSize: 20000 },
      }),
      CrudStoreItemPartner360.JBPDistributorScopeData
    )
    CrudStore.add(
      new Crud<IFormDistributorScopeSummary>({
        fetcher: new CrudInnerStorageFetcher<IFormDistributorScopeSummary>('UniqueId', {
          formId: 625,
          code: 'JBPDistributorScopeDataSummary',
        }),
        keyField: 'UniqueId',
        defaultPaging: { page: 0, pageSize: 20000 },
      }),
      CrudStoreItemPartner360.JBPDistributorScopeDataSummary
    )
    CrudStore.add(
      new Crud<IFormDistributorScopeDetails>({
        fetcher: new CrudInnerStorageFetcher<IFormDistributorScopeDetails>('UniqueId', {
          formId: 625,
          code: 'JBPDistributorScopeDataDetails',
        }),
        keyField: 'UniqueId',
        defaultPaging: { page: 0, pageSize: 20000 },
      }),
      CrudStoreItemPartner360.JBPDistributorScopeDataDetails
    )
    CrudStore.add(
      new Crud<IFormDistributorBridges>({
        fetcher: new CrudInnerStorageFetcher<IFormDistributorBridges>('EntryId', {
          formId: 1071,
          code: 'distributors-business-planning-1071',
        }),
        keyField: 'EntryId',
      }),
      CrudStoreItemPartner360.JBPDistributorBridges
    )
    CrudStore.add(
      new Crud<IBridge>({
        fetcher: new CrudInnerStorageFetcher<IBridge>('Id', {
          formId: 1071,
          code: 'JBPBridges',
        }),
        keyField: 'Id',
        defaultSort: { field: 'FQuarter', dir: 'asc' },
        defaultPaging: { page: 0, pageSize: 30 },
      }),
      CrudStoreItemPartner360.JBPBusinessBridges
    )
    CrudStore.add(
      new Crud({
        fetcher: new ProcedureInnerStorageFetcher('uuid', {
          readFromTo: async (filter) => {
            const parameters = getFetchJbpFilters(filter)
            return await fetchJBPBridges(parameters)
          },
        }),
        keyField: 'uuid',
        defaultPaging: {
          page: 0,
          pageSize: 10000,
        },
      }),
      CrudStoreItemPartner360.JBPBridges
    )
    CrudStore.add(
      new Crud<IBridge>({
        fetcher: new CrudInnerStorageFetcher<IBridge>('Id', {
          formId: 1071,
          code: 'JBPBridgesByProducts',
        }),
        keyField: 'Id',
        defaultPaging: { page: 0, pageSize: 30 },
      }),
      CrudStoreItemPartner360.JBPProductBridges
    )
    CrudStore.add(
      new Crud<IFormDistributorInventory>({
        fetcher: new CrudInnerStorageFetcher<IFormDistributorInventory>('EntryId', {
          formId: 1130,
          code: 'JBPDistributorInventory',
        }),
        keyField: 'EntryId',
      }),
      CrudStoreItemPartner360.JBPDistributorInventory
    )
    CrudStore.add(
      new Crud<IFormDistributorInventoryAmbition>({
        fetcher: new CrudInnerStorageFetcher<IFormDistributorInventoryAmbition>('EntryId', {
          formId: 1138,
          code: 'distributor-inventory-planning-1138',
        }),
        keyField: 'EntryId',
      }),
      CrudStoreItemPartner360.JBPDistributorInventoryAmbition
    )
    CrudStore.add(
      new Crud<IFormPartner360Attachments>({
        fetcher: new CrudInnerStorageFetcher<IFormPartner360Attachments>('EntryId', {
          formId: 1073,
          code: 'JBPPartnerAttachments',
        }),
        keyField: 'EntryId',
      }),
      CrudStoreItemPartner360.JBPPartnerAttachments
    )
    CrudStore.add(
      new Crud<IFormPartner360Statistics>({
        fetcher: new CrudInnerStorageFetcher<IFormPartner360Statistics>('EntryId', {
          formId: 1238,
          code: 'partner-360-statistics-1238',
        }),
        keyField: 'EntryId',
      }),
      CrudStoreItemPartner360.JBPPartnerStatistics
    )
    CrudStore.add(
      new Crud<IFormMIFReport>({
        fetcher: new CrudInnerStorageFetcher<IFormMIFReport>('StrategicInitiative', {
          formId: 625,
          code: 'StrategicInitiatives',
        }),
        keyField: 'StrategicInitiative',
      }),
      CrudStoreItemPartner360.StrategicInitiative
    )
    CrudStore.add(
      new Crud<IFormMIFReport>({
        fetcher: new CrudInnerStorageFetcher<IFormMIFReport>('EntryId', {
          formId: 877,
          code: 'LongTermStrategyCategories',
        }),
        keyField: 'EntryId',
        defaultSort: [
          { field: 'FYearCreated', dir: 'desc' },
          { field: 'EntryId', dir: 'desc' },
        ],
        defaultPaging: { page: 0, pageSize: 100000 },
      }),
      CrudStoreItemPartner360.ActionPlans
    )
    CrudStore.add(
      new Crud<IFormMIFReport>({
        fetcher: new CrudInnerStorageFetcher('EntryId', {
          formId: 877,
          code: 'JBPLongTermStrategies',
        }),
        keyField: 'EntryId',
        defaultSort: [
          { field: 'FYearCreated', dir: 'desc' },
          { field: 'EntryId', dir: 'desc' },
        ],
        defaultPaging: { page: 0, pageSize: 100000 },
      }),
      CrudStoreItemPartner360.JBPLongTermStrategies
    )
    CrudStore.add(
      new Crud({
        fetcher: new ProcedureInnerStorageFetcher('EntryId', {
          readFromTo: async (filter) => await fetchGPLongTermsRollup(filter),
        }),
        keyField: 'EntryId',
        defaultPaging: {
          page: 0,
          pageSize: 1500,
        },
      }),
      CrudStoreItemPartner360.JBPGPLongTermsRollup
    )
    CrudStore.add(
      new Crud<IFormExecutiveReport>({
        fetcher: new CrudInnerStorageFetcher<IFormExecutiveReport>('PartnerId', {
          formId: 867,
          code: 'JBPExecutiveReport',
        }),
        keyField: 'PartnerId',
        defaultPaging: { page: 0, pageSize: 10 },
      }),
      CrudStoreItemPartner360.JBPExecutiveReport
    )
    CrudStore.add(
      new Crud<IFormSalesTeamBusinessUnits>({
        fetcher: new CrudInnerStorageFetcher<IFormSalesTeamBusinessUnits>('BusinessUnit', {
          formId: 887,
          code: 'SalesTeamBusinessUnits',
        }),
        keyField: 'BusinessUnit',
        defaultPaging: { page: 0, pageSize: 100 },
      }),
      CrudStoreItemPartner360.SalesTeamBusinessUnit
    )
    CrudStore.add(
      new Crud<IFormSalesTeamRoles>({
        fetcher: new CrudInnerStorageFetcher<IFormSalesTeamRoles>('Roles', {
          formId: 887,
          code: 'SalesTeamRoles',
        }),
        keyField: 'Roles',
        defaultPaging: { page: 0, pageSize: 100 },
      }),
      CrudStoreItemPartner360.SalesTeamRoles
    )
    CrudStore.add(
      new Crud<IFormSOBResults>({
        fetcher: new CrudInnerStorageFetcher<IFormSOBResults>('EntryId', {
          formId: 838,
          code: 'JBPSOBResults',
        }),
        keyField: 'EntryId',
      }),
      CrudStoreItemPartner360.SOBResults
    )
    CrudStore.add(
      new Crud<IFormSOBResults>({
        fetcher: new CrudInnerStorageFetcher<any>('EntryId', {
          formId: 625,
          code: 'JBPMdfOpexFunds',
        }),
        keyField: 'EntryId',
      }),
      CrudStoreItemPartner360.JBPMdfOpexFunds
    )
    CrudStore.add(
      new Crud<IFormTopPartnerSummaryReport>({
        fetcher: new CrudInnerStorageFetcher<IFormTopPartnerSummaryReport>('UniqueId', {
          formId: 630,
          code: 'JBPTopPartnerSummaryReport',
        }),
        keyField: 'UniqueId',
      }),
      CrudStoreItemPartner360.TopPartnerSummaryReport
    )
    CrudStore.add(
      new Crud<IFormTopPartners>({
        fetcher: new CrudInnerStorageFetcher<IFormTopPartners>('EntryId', {
          formId: 1223,
          code: 'JBPTopPartners',
        }),
        keyField: 'EntryId',
      }),
      CrudStoreItemPartner360.JBPTopPartners
    )
    CrudStore.add(
      new Crud<IFormTopPartnersToAdd>({
        fetcher: new CrudInnerStorageFetcher<IFormTopPartnersToAdd>('PartnerId', {
          formId: 1223,
          code: 'JBPTopPartnersToAdd',
        }),
        keyField: 'PartnerId',
      }),
      CrudStoreItemPartner360.JBPTopPartnersToAdd
    )
    CrudStore.add(
      new Crud<IFormActualsTargetsSettings>({
        fetcher: new CrudInnerStorageFetcher<IFormActualsTargetsSettings>('EntryId', {
          formId: 951,
          code: 'JBPActualsAndTargetsSettings',
        }),
        keyField: 'EntryId',
        defaultPaging: { page: 0, pageSize: 1000 },
        defaultSort: [
          { field: 'CategoryOrder', dir: 'asc' },
          { field: 'SubCategoryOrder', dir: 'asc' },
        ],
      }),
      CrudStoreItemPartner360.ActualsTargetsSettings
    )
    CrudStore.add(
      new Crud<IFormMarketDeepDive>({
        fetcher: new CrudInnerStorageFetcher<IFormMarketDeepDive>('EntryId', {
          formId: 1081,
          code: 'JBPMarketDeepDive',
        }),
        keyField: 'EntryId',
        defaultPaging: { page: 0, pageSize: 100 },
      }),
      CrudStoreItemPartner360.JBPMarketDeepDive
    )
    CrudStore.add(
      new Crud<IFormSwotData>({
        fetcher: new CrudInnerStorageFetcher<IFormSwotData>('EntryId', {
          formId: 1084,
          code: 'JBPSwotData',
        }),
        keyField: 'EntryId',
        defaultPaging: { page: 0, pageSize: 100 },
      }),
      CrudStoreItemPartner360.JBPSwotData
    )
    CrudStore.add(
      new Crud<IFormTopPartnerSummaryReport>({
        fetcher: new CrudInnerStorageFetcher<any>('EntryId', {
          formId: 957,
          code: 'cloud-certifications-957',
        }),
        keyField: 'EntryId',
        connectorFetchFn: CrudConnectorsPartner360.fetchCetificates,
      }),
      CrudStoreItemPartner360.CloudCertificationsWithConnector
    )
    CrudStore.add(
      new Crud<IFormTopPartnerSummaryReport>({
        fetcher: new CrudInnerStorageFetcher<any>('EntryId', {
          formId: 957,
          code: 'cloud-certifications-957',
        }),
        keyField: 'EntryId',
      }),
      CrudStoreItemPartner360.CloudCertifications
    )
    CrudStore.add(
      new Crud<IFormPBMManagers>({
        fetcher: new CrudInnerStorageFetcher<IFormPBMManagers>('EntryId', {
          formId: 950,
          code: 'pbm-managers-950',
        }),
        keyField: 'EntryId',
      }),
      CrudStoreItemPartner360.PBMManagers
    )
    CrudStore.add(
      new Crud<IFormJBPPBMManagers>({
        fetcher: new CrudInnerStorageFetcher<IFormJBPPBMManagers>('PBMEmail', {
          formId: 950,
          code: 'JBPPBMManagers',
        }),
        keyField: 'PBMEmail',
      }),
      CrudStoreItemPartner360.JBPPBMManagers
    )
    CrudStore.add(
      new Crud<IFormNdpRate>({
        fetcher: new CrudInnerStorageFetcher<IFormNdpRate>('UniqueId', {
          formId: 964,
          code: 'JBPNetNdpRates',
        }),
        keyField: 'UniqueId',
      }),
      CrudStoreItemPartner360.JBPNdpRate
    )
    CrudStore.add(
      new Crud<IFormDigitalAssessment>({
        fetcher: new CrudInnerStorageFetcher<IFormDigitalAssessment>('EntryId', {
          formId: 980,
          code: 'digital-capability-assessment-980',
        }),
        keyField: 'EntryId',
      }),
      CrudStoreItemPartner360.JBPDigitalAssessment
    )
    CrudStore.add(
      new Crud<IFormDigitalAssessment>({
        fetcher: new CrudInnerStorageFetcher<IFormDigitalAssessment>('EntryId', {
          formId: 987,
          code: 'digital-capability-recommendations-987',
        }),
        keyField: 'EntryId',
      }),
      CrudStoreItemPartner360.JBPDigitalAssessmentRecommendations
    )
    CrudStore.add(
      new Crud<IFormOfferings>({
        fetcher: new CrudInnerStorageFetcher<IFormOfferings>('UniqueId', {
          formId: 621,
          code: 'JBPOfferings',
        }),
        defaultSort: { field: 'OrderBy', dir: 'asc' },
        keyField: 'UniqueId',
      }),
      CrudStoreItemPartner360.JBPOfferings
    )
    CrudStore.add(
      new Crud<IFormOfferingList>({
        fetcher: new CrudInnerStorageFetcher<IFormOfferingList>('Offering', {
          formId: 590,
          code: 'JBPOfferingsList',
        }),
        defaultSort: { field: 'OrderBy', dir: 'asc' },
        keyField: 'Offering',
      }),
      CrudStoreItemPartner360.JBPOfferingsList
    )
    CrudStore.add(
      new Crud<IFormJBPReportType>({
        fetcher: new CrudInnerStorageFetcher<IFormJBPReportType>('EntryId', {
          formId: 1089,
          code: 'JBPReportType',
        }),
        keyField: 'EntryId',
        defaultSort: { field: 'OrderBy', dir: 'asc' },
        defaultPaging: { page: 0, pageSize: 100 },
      }),
      CrudStoreItemPartner360.JBPReportType
    )
    CrudStore.add(
      new Crud<IFormTTAFormatType>({
        fetcher: new CrudInnerStorageFetcher<IFormTTAFormatType>('EntryId', {
          formId: 951,
          code: 'JBPTTAFormatType',
        }),
        keyField: 'EntryId',
        defaultSort: { field: 'CategoryOrder', dir: 'asc' },
        defaultPaging: { page: 0, pageSize: 100 },
      }),
      CrudStoreItemPartner360.JBPTTAFormatType
    )
    CrudStore.add(
      new Crud<IFormJBPPartnerDataDynamic>({
        fetcher: new CrudInnerStorageFetcher<IFormJBPPartnerDataDynamic>('UniqueId', {
          formId: 621,
          code: 'JBPPartnerDataDynamic',
        }),
        keyField: 'UniqueId',
      }),
      CrudStoreItemPartner360.JBPPartnerDataDynamic
    )
    CrudStore.add(
      new Crud<IPartnerScopeEntity>({
        fetcher: new CrudInnerStorageFetcher<IPartnerScopeEntity>('EntryId', {
          formId: 590,
          code: 'JBPPartnerScope',
        }),
        keyField: 'EntryId',
        defaultSort: { field: 'EntryId', dir: 'desc' },
      }),
      CrudStoreItemPartner360.JBPPartnerScopeManagement
    )
    CrudStore.add(
      new Crud<IELTData>({
        fetcher: new CrudInnerStorageFetcher<IELTData>('EntryId', {
          formId: 590,
          code: 'JBPELTForm',
        }),
        keyField: 'EntryId',
        defaultSort: { field: 'EntryId', dir: 'desc' },
      }),
      CrudStoreItemPartner360.JBPEltData
    )
    CrudStore.add(
      new Crud<IELTFinancialData>({
        fetcher: new CrudInnerStorageFetcher<IELTFinancialData>('PartnerId', {
          formId: 590,
          code: 'JBPELTFinancialData',
        }),
        keyField: 'PartnerId',
      }),
      CrudStoreItemPartner360.JBPELTFinancialData
    )
    CrudStore.add(
      new Crud<IELTFinancialData>({
        fetcher: new CrudInnerStorageFetcher<IELTFinancialData>('PartnerGroup', {
          formId: 590,
          code: 'JBPELTFinancialDataGroup',
        }),
        keyField: 'PartnerGroup',
      }),
      CrudStoreItemPartner360.JBPELTFinancialDataGroup
    )
    CrudStore.add(
      new Crud<ITopPartnerFromT1263>({
        fetcher: new CrudInnerStorageFetcher<ITopPartnerFromT1263>('EntryId', {
          formId: 1263,
          code: 'partner-global-groups-1263',
        }),
        defaultSort: { field: 'EntryId', dir: 'desc' },
        keyField: 'EntryId',
      }),
      CrudStoreItemPartner360.JBPGroupGeneralInfo
    )
    CrudStore.add(
      new Crud<IPartnerGlobalGroup>({
        fetcher: new CrudInnerStorageFetcher<IPartnerGlobalGroup>('EntryId', {
          formId: 1263,
          code: 'JBPPartnerGlobalGroups',
        }),
        defaultSort: { field: 'EntryId', dir: 'desc' },
        keyField: 'EntryId',
      }),
      CrudStoreItemPartner360.JBPPartnerGlobalGroups
    )
    CrudStore.add(
      new Crud<IPartnerGroupFromT1187>({
        fetcher: new CrudInnerStorageFetcher<IPartnerGroupFromT1187>('EntryId', {
          formId: 1187,
          code: 'partner-global-linkage-1187',
        }),
        defaultSort: { field: 'EntryId', dir: 'desc' },
        keyField: 'EntryId',
      }),
      CrudStoreItemPartner360.JBPPartnerGroups
    )
    CrudStore.add(
      new Crud<IJBPPartnerGroupsExtData>({
        fetcher: new CrudInnerStorageFetcher<IJBPPartnerGroupsExtData>('EntryId', {
          formId: 1187,
          code: 'JBPPartnerGroupsExtData',
        }),
        defaultSort: { field: 'EntryId', dir: 'desc' },
        keyField: 'EntryId',
      }),
      CrudStoreItemPartner360.JBPPartnerGroupsExtData
    )
    CrudStore.add(
      new Crud<IJBPPartnerGroupsExtData>({
        fetcher: new CrudInnerStorageFetcher<IJBPPartnerGroupsExtData>('EntryId', {
          formId: 1379,
          code: 'JBPPartnerGPExtData',
        }),
        defaultSort: { field: 'EntryId', dir: 'desc' },
        defaultPaging: { page: 0, pageSize: 200 },
        keyField: 'EntryId',
      }),
      CrudStoreItemPartner360.JBPPGlobalPartnersEntities
    )
    CrudStore.add(
      new Crud<IJBPCountMembersInGroup>({
        fetcher: new CrudInnerStorageFetcher<IJBPCountMembersInGroup>('PartnerGroup', {
          formId: 1187,
          code: 'JBPCountMembersInGroup',
        }),
        keyField: 'PartnerGroup',
      }),
      CrudStoreItemPartner360.JBPCountMembersInGroup
    )
    CrudStore.add(
      new Crud<IPartnerGroupInfo>({
        fetcher: new CrudInnerStorageFetcher<IPartnerGroupInfo>('EntryId', {
          formId: 1187,
          code: 'JBPPartnerGroupInfo',
        }),
        keyField: 'EntryId',
      }),
      CrudStoreItemPartner360.JBPPartnerGroupInfo
    )
    CrudStore.add(
      new Crud<IJBPGroupMembersString>({
        fetcher: new CrudInnerStorageFetcher<IJBPGroupMembersString>('GroupId', {
          formId: 1187,
          code: 'JBPGroupMembersString',
        }),
        keyField: 'GroupId',
      }),
      CrudStoreItemPartner360.JBPGroupMembersString
    )
    CrudStore.add(
      new Crud<IELTContact>({
        fetcher: new CrudInnerStorageFetcher<IELTContact>('Email', {
          formId: 1233,
          code: 'JBPELTContacts',
        }),
        keyField: 'Email',
      }),
      CrudStoreItemPartner360.JBPELTContacts
    )
    CrudStore.add(
      new Crud<IELTHPContact>({
        fetcher: new CrudInnerStorageFetcher<IELTHPContact>('Email', {
          formId: 1233,
          code: 'JBPELTHPContacts',
        }),
        keyField: 'Email',
      }),
      CrudStoreItemPartner360.JBPELTHPContacts
    )
    CrudStore.add(
      new Crud<IELTSearch>({
        fetcher: new CrudInnerStorageFetcher<IELTSearch>('EntryId', {
          formId: 590,
          code: 'JBPELTSearch',
        }),
        defaultSort: { field: 'EntryId', dir: 'desc' },
        keyField: 'EntryId',
      }),
      CrudStoreItemPartner360.JBPEltSearch
    )
    CrudStore.add(
      new Crud<IELTVersionsCount>({
        fetcher: new CrudInnerStorageFetcher<IELTVersionsCount>('PartnerId', {
          formId: 1233,
          code: 'JBPELTVersions',
        }),
        keyField: 'PartnerId',
      }),
      CrudStoreItemPartner360.JBPELTVersionsCount
    )
    CrudStore.add(
      new Crud<IELTVersionsCount>({
        fetcher: new CrudInnerStorageFetcher<IELTVersionsCount>('PartnerId', {
          formId: 951,
          code: 'JBPTargetCategoriesForTree',
        }),
        keyField: 'PartnerId',
        defaultPaging: { page: 0, pageSize: 50 },
      }),
      CrudStoreItemPartner360.JBPTargetCategoriesForTree
    )

    CrudStore.add(
      new Crud<IComposedReport>({
        fetcher: new ProcedureInnerStorageFetcher<IComposedReport>('PartnerId', {
          readFromTo: async (filter, sort, paging) => await fetchReportData(filter, paging),
        }),
        keyField: 'PartnerId',
        defaultPaging: { page: 0, pageSize: 15 },
        skipPagingTransform: true,
      }),
      CrudStoreItemPartner360.JBPComposedReport
    )

    CrudStore.add(
      new Crud<IWWPartners>({
        fetcher: new ProcedureInnerStorageFetcher<IWWPartners>('PartnerID', {
          readFromTo: async (filter) => await fetchPartnersByPartnerIds(filter),
        }),
        keyField: 'PartnerID',
        skipPagingTransform: true,
      }),
      CrudStoreItemPartner360.JBPComposedReportClipBoard
    )
    CrudStore.add(
      new Crud<IComposedReportFilters>({
        fetcher: new CrudInnerStorageFetcher<IComposedReportFilters>('EntryId', {
          formId: 1350,
          code: 'composed-repors-saved-filters-1350',
        }),
        keyField: 'EntryId',
        defaultPaging: { page: 0, pageSize: 50 },
      }),
      CrudStoreItemPartner360.JBPComposedReportFilters
    )

    CrudStore.add(
      new Crud<IPbmListItem>({
        fetcher: new CrudInnerStorageFetcher<IPbmListItem>('Email', {
          formId: 613,
          code: 'JBPPBMs',
        }),
        keyField: 'Email',
        defaultSort: { field: 'Email', dir: 'asc' },
        defaultPaging: { page: 0, pageSize: 1300 },
      }),
      CrudStoreItemPartner360.JBPPBMs
    )

    CrudStore.add(
      new Crud<IManagerMiltuselect>({
        fetcher: new CrudInnerStorageFetcher<IManagerMiltuselect>('Email', {
          formId: 613,
          code: 'JBPManagers',
        }),
        keyField: 'Email',
        defaultSort: { field: 'Email', dir: 'asc' },
        defaultPaging: { page: 0, pageSize: 300 },
      }),
      CrudStoreItemPartner360.JBPManagers
    )

    CrudStore.add(
      new Crud<IManagerMiltuselect>({
        fetcher: new CrudInnerStorageFetcher('Title', {
          formId: 1593,
          code: 'JBPSpecializations',
        }),
        keyField: 'Title',
        defaultFilter: {
          logic: Logic.AND,
          filters: [
            {
              field: 'rtm',
              operator: Operator.EQUAL,
              value: 'Commercial',
            },
          ],
        },
        defaultPaging: { page: 0, pageSize: 300 },
      }),
      CrudStoreItemPartner360.JBPSpecializations
    )

    CrudStore.add(
      new Crud({
        fetcher: new CrudInnerStorageFetcher('PartnerID', {
          formId: 621,
          code: 'JBPComposedReportPartnersScope',
        }),
        keyField: 'PartnerID',
      }),
      CrudStoreItemPartner360.JBPComposedReportPartnersScope
    )

    CrudStore.add(
      new Crud({
        fetcher: new ProcedureInnerStorageFetcher('GlobalPartnerId', {
          readFromTo: async (filter, sort, paging) => await fetchGlobalPartners(filter, paging),
        }),
        keyField: 'GlobalPartnerId',
        defaultPaging: { page: 0, pageSize: 15 },
        skipPagingTransform: true,
      }),
      CrudStoreItemPartner360.JBPGlobalPartnerTableData
    )

    CrudStore.add(
      new Crud({
        fetcher: new ProcedureInnerStorageFetcher('PartnerID', {
          readFromTo: async (filter) => await fetchPartnersToAdd(filter),
        }),
        keyField: 'PartnerID',
        defaultPaging: { page: 0, pageSize: 15 },
        skipPagingTransform: true,
      }),
      CrudStoreItemPartner360.JBPFetchPartnersToAdd
    )

    CrudStore.add(
      new Crud({
        fetcher: new CrudInnerStorageFetcher('EntryId', {
          formId: 1379,
          code: 'global-partners-1379',
        }),
        keyField: 'EntryId',
        defaultPaging: { page: 0, pageSize: 50 },
      }),
      CrudStoreItemPartner360.JBPGlobalPartnerData
    )

    CrudStore.add(
      new Crud({
        fetcher: new CrudInnerStorageFetcher('ContactID', {
          formId: 1379,
          code: 'JBPGlobalPartnerPartnersContacts',
        }),
        keyField: 'ContactID',
        defaultPaging: { page: 0, pageSize: 5 },
      }),
      CrudStoreItemPartner360.JBPGlobalPartnerPartnersContacts
    )

    CrudStore.add(
      new Crud({
        fetcher: new CrudInnerStorageFetcher('ContactId', {
          formId: 700,
          code: 'JBPGlobalPartnerContacts',
        }),
        keyField: 'ContactId',
        defaultPaging: { page: 0, pageSize: 5 },
      }),
      CrudStoreItemPartner360.JBPGlobalPartnerContacts
    )

    CrudStore.add(
      new Crud({
        fetcher: new ProcedureInnerStorageFetcher('EntryId', {
          readFromTo: async (filter: IDataProviderFilter) => {
            const filters = filter.filters as IFilter[]
            const globalPartnerId = filters.find((it) => it.field === 'GlobalPartnerId')

            const pbmFilter = filters.find((it) => it.field === 'Pbms')
            const productTreeFilter = filters.find((it) => it.field === 'Products')
            const geoMappingFilter = filters.find((it) => it.field === 'Geo')
            const partnerIdFilter = filters.find((it) => it.field === 'PartnerIds')
            const managerFilter = filters.find((it) => it.field === 'Managers')

            if (
              !globalPartnerId ||
              !pbmFilter ||
              !productTreeFilter ||
              !geoMappingFilter ||
              !partnerIdFilter ||
              !managerFilter
            ) {
              return []
            }

            // TODO: Temporary type definition. Need to replace any with actual type.
            return (await fetchGlobalPartnerDetails({
              globalPartnerId: globalPartnerId.value as string,
              pbmFilter:
                typeof pbmFilter?.value === 'string'
                  ? pbmFilter.value.split(',').filter((it) => it)
                  : [],
              productTreeFilter:
                typeof productTreeFilter?.value === 'string'
                  ? productTreeFilter.value.split(',').filter((it) => it)
                  : [],
              geoMappingsFilter:
                typeof geoMappingFilter?.value === 'string'
                  ? geoMappingFilter.value.split(',').filter((it) => it)
                  : [],
              partnerIdFilter:
                typeof partnerIdFilter?.value === 'string'
                  ? partnerIdFilter.value.split(',').filter((it) => it)
                  : [],
              managerFilter:
                typeof managerFilter?.value === 'string'
                  ? managerFilter.value.split(',').filter((it) => it)
                  : [],
            })) as any
          },
        }),
        keyField: 'EntryId',
        defaultPaging: {
          page: 0,
          pageSize: 1500,
        },
      }),
      CrudStoreItemPartner360.JBPGlobalPartnerDetails
    )

    CrudStore.add(
      new Crud({
        fetcher: new ProcedureInnerStorageFetcher('EntryId', {
          readFromTo: async (filter) => await fetchGPKeyInitiativesRollup(filter),
        }),
        keyField: 'EntryId',
        defaultPaging: {
          page: 0,
          pageSize: 1500,
        },
      }),
      CrudStoreItemPartner360.JBPGPKeyInitiativesRollup
    )

    CrudStore.add(
      new Crud({
        fetcher: new CrudInnerStorageFetcher('PartnerID', {
          formId: 621,
          code: 'JBPPartners',
        }),
        keyField: 'PartnerID',
        defaultPaging: { page: 0, pageSize: 10 },
      }),
      CrudStoreItemPartner360.JBPPartners
    )

    CrudStore.add(
      new Crud({
        fetcher: new CrudInnerStorageFetcher('PartnerId', {
          formId: 1379,
          code: 'JBPGlobalPartnerPartnerInfo',
        }),
        keyField: 'PartnerId',
        defaultPaging: { page: 0, pageSize: 10 },
      }),
      CrudStoreItemPartner360.JBPGlobalPartnerPartnerInfo
    )

    CrudStore.add(
      new Crud({
        fetcher: new CrudInnerStorageFetcher('PartnerId', {
          formId: 801,
          code: 'JBPAmplifyImpactInfo',
        }),
        keyField: 'PartnerId',
      }),
      CrudStoreItemPartner360.JBPAmplifyImpactInfo
    )

    CrudStore.add(
      new Crud({
        fetcher: new CrudInnerStorageFetcher('EntryId', {
          formId: 1084,
          code: 'JBPSWOTRollup',
        }),
        keyField: 'EntryId',
      }),
      CrudStoreItemPartner360.JbpSwotRollup
    )

    CrudStore.add(
      new Crud<IQBRForm1554>({
        fetcher: new CrudInnerStorageFetcher<IQBRForm1554>('EntryId', {
          formId: 1554,
          code: 'qbr-document-1554',
        }),
        keyField: 'EntryId',
      }),
      CrudStoreItemPartner360.JBPQBRDocument
    )

    CrudStore.add(
      new Crud({
        fetcher: new CrudInnerStorageFetcher('EntryId', {
          formId: 1559,
          code: 'qbr-attachments-1559',
        }),
        keyField: 'EntryId',
      }),
      CrudStoreItemPartner360.JbpQbrAttachments
    )
    CrudStore.add(
      new Crud({
        fetcher: new CrudInnerStorageFetcher<IP360Ticket>('EntryId', {
          formId: 1566,
          code: 'p-360-tickets-1566',
        }),
        keyField: 'EntryId',
      }),
      CrudStoreItemPartner360.JBPTickets
    )
    CrudStore.add(
      new Crud({
        fetcher: new ProcedureInnerStorageFetcher('PartnerId', {
          readFromTo: async (filter) => callSobTrendsPartnerSearchFromCrud(filter),
        }),
        keyField: 'PartnerId',
      }),
      CrudStoreItemPartner360.JBPSobTrendsPartnerSearch
    )
  }
}

export default new InitializationServicePartner360()
